import { render, staticRenderFns } from "./IconGrid.vue?vue&type=template&id=054bddec"
import script from "./IconGrid.vue?vue&type=script&lang=js"
export * from "./IconGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports